module.exports = __webpack_public_path__ + "img/m_cloes_white.ee513779.svg";